import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const getSingleCoachingNote = gql`
  query GetSingleCoachingNote($noteID: String!, $userID: String) {
    getSingleCoachingNote(noteID: $noteID, userID: $userID) {
      id
      coachingId
      coach {
        userID
        userName
      }
      recipient {
        userID
        userName
      }
      deliveredBy {
        userID
        userName
      }
      reviewedBy {
        userID
        userName
      }
      closedBy {
        userID
        userName
      }
      createdAt
      deliveredAt
      reviewedAt
      closedAt
      updatedAt
      isDelivered
      ... on Coaching {
        contactReview {
          cscContactID
          marketplaceID
          marketplaceDomainName
          followedSecurityPolicies
          content
          vertical
          relatedMetric
          contactTime {
            calWeek
            calYear
          }
        }
        coachingDetails {
          coachingTopic
          relatedContacts
          relatedContactDomains {
            cscContactID
            marketplaceDomainName
          }
          tenets
          behaviors
          relatedMetric
          assignedAction
          status
        }
        coachingSession {
          managerNotes
          coachingTactic
          coachingMethod
          duration
          preparationTime
          coachingSummaryNotes
        }
      }
      ... on NoCoach {
        reason
        otherReason
      }
    }
  }
`;
